import { Link } from "react-router-dom";
import { useAppSetting } from "../../context/appSettingContext";

function Navbar(props) {
  const activePage = props.activePage;

  const { clientAccess } = useAppSetting();

  // Function to trigger device vibration
  const triggerVibration = () => {
    if (navigator.vibrate) {
      // Vibrate for 200 milliseconds
      navigator.vibrate([25]);
    }
  };

  console.log(clientAccess, "clientAccess");
  if (clientAccess) {
    const voucherAccess = clientAccess.find(
      (access) => access.access_desc === "Voucher"
    );

    const billHistory = clientAccess.find(
      (access) => access.access_desc === "Bill History"
    );
    const homeAccess = clientAccess.find(
      (access) => access.access_desc === "Home"
    );
    const offersAccess = clientAccess.find(
      (access) => access.access_desc === "Offers"
    );
    const profileAccess = clientAccess.find(
      (access) => access.access_desc === "Profile"
    );

    return (
      <div
        style={{ boxShadow: "0 2px 20px rgba(0, 0, 0, 0.20)" }}
        className="wafaa-navigation w-100 bg-wafaa-white-2 height-70 position-fixed bottom-0 d-flex align-items-center justify-content-around max-width-700"
      >
        {homeAccess?.enabled && (
          <Link
            to="/home"
            onClick={triggerVibration}
            className={
              activePage === "home"
                ? "text-decoration-none h-60 active"
                : "text-decoration-none h-60"
            }
          >
            <div className="d-flex flex-column justify-content-around align-items-center">
              <svg
                width="33"
                height="26"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.4585 28.5V12.5L16.1252 4.5L26.7918 12.5V28.5H18.7918V19.1667H13.4585V28.5H5.4585Z"
                  fill="#8690AB"
                />
              </svg>
              <p className="mb-0 font-size-12">Home</p>
            </div>
          </Link>
        )}

        {offersAccess?.enabled && (
          <Link
            to="/offers"
            onClick={triggerVibration}
            className={
              activePage === "offers"
                ? "text-decoration-none h-60 active"
                : "text-decoration-none h-60"
            }
          >
            <div className="d-flex flex-column justify-content-around align-items-center">
              <svg
                width="33"
                height="26"
                viewBox="0 0 33 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.70817 6.66663C5.00093 6.66663 4.32265 6.99148 3.82255 7.56971C3.32246 8.14795 3.0415 8.93221 3.0415 9.74996V15.9166C3.74875 15.9166 4.42703 16.2415 4.92712 16.8197C5.42722 17.398 5.70817 18.1822 5.70817 19C5.70817 19.8177 5.42722 20.602 4.92712 21.1802C4.42703 21.7584 3.74875 22.0833 3.0415 22.0833V28.25C3.0415 29.0677 3.32246 29.852 3.82255 30.4302C4.32265 31.0084 5.00093 31.3333 5.70817 31.3333H27.0415C27.7487 31.3333 28.427 31.0084 28.9271 30.4302C29.4272 29.852 29.7082 29.0677 29.7082 28.25V22.0833C29.0009 22.0833 28.3226 21.7584 27.8226 21.1802C27.3225 20.602 27.0415 19.8177 27.0415 19C27.0415 18.1822 27.3225 17.398 27.8226 16.8197C28.3226 16.2415 29.0009 15.9166 29.7082 15.9166V9.74996C29.7082 8.93221 29.4272 8.14795 28.9271 7.56971C28.427 6.99148 27.7487 6.66663 27.0415 6.66663H5.70817ZM21.0415 11.2916L23.0415 13.6041L11.7082 26.7083L9.70817 24.3958L21.0415 11.2916ZM12.1215 11.3533C13.4282 11.3533 14.4815 12.5712 14.4815 14.082C14.4815 14.8058 14.2329 15.4998 13.7903 16.0116C13.3477 16.5233 12.7474 16.8108 12.1215 16.8108C10.8148 16.8108 9.7615 15.5929 9.7615 14.082C9.7615 13.3583 10.0101 12.6643 10.4527 12.1525C10.8953 11.6408 11.4956 11.3533 12.1215 11.3533ZM20.6282 21.1891C21.9348 21.1891 22.9882 22.407 22.9882 23.9179C22.9882 24.6416 22.7395 25.3357 22.2969 25.8474C21.8544 26.3591 21.2541 26.6466 20.6282 26.6466C19.3215 26.6466 18.2682 25.4287 18.2682 23.9179C18.2682 23.1942 18.5168 22.5001 18.9594 21.9884C19.402 21.4766 20.0023 21.1891 20.6282 21.1891Z"
                  fill="#8690AB"
                />
              </svg>
              <p className="mb-0 font-size-12">Offers</p>
            </div>
          </Link>
        )}

        {voucherAccess?.enabled && (
          <Link
            to="/vouchers"
            onClick={triggerVibration}
            className={
              activePage === "vouchers"
                ? "text-decoration-none h-60 active"
                : "text-decoration-none h-60"
            }
          >
            <div className="d-flex flex-column justify-content-around align-items-center">
              <svg
                fill="#8690AB"
                width="33"
                height="26"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 512 512"
                xmlSpace="preserve"
              >
                <g>
                  <g>
                    <path
                      d="M92.164,186.126c-7.384,0-11.67,3.573-11.67,11.433v33.824c0,7.861,4.287,11.433,11.67,11.433
                                c7.385,0,11.911-3.573,11.911-11.433V197.56C104.075,189.699,99.549,186.126,92.164,186.126z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="M201.498,262.825c-7.384,0-11.671,3.573-11.671,11.433v33.824c0,7.86,4.289,11.433,11.671,11.433
                                s11.91-3.573,11.91-11.433v-33.824C213.407,266.399,208.882,262.825,201.498,262.825z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="M496.607,94.801H337.077l-0.736,0.736l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112
                                c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112l13.112,13.112c10.517,10.517,10.517,27.63,0,38.147l-13.112,13.112
                                l13.112,13.112c5.096,5.094,7.901,11.868,7.901,19.073
                                c0,7.206-2.806,13.98-7.901,19.074l-12.919,12.92h160.072c8.501,0,15.393-6.892,15.393-15.393V110.195
                                C512,101.693,505.108,94.801,496.607,94.801z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="M321.306,192.095l-13.112-13.112c-5.096-5.094-7.901-11.868-7.901-19.073c0-7.206,2.806-13.98,7.901-19.074l13.112-13.112
                                l-13.112-13.112c-5.445-5.445-8.046-12.658-7.853-19.809H15.393C6.892,94.801,0,101.693,0,110.195v291.611
                                c0,8.501,6.892,15.393,15.393,15.393h284.905c0.049-7.132,2.846-13.832,7.896-18.881l13.112-13.112l-13.112-13.112
                                c-10.517-10.517-10.517-27.63,0-38.147l13.112-13.112l-13.112-13.112c-10.517-10.517-10.517-27.63,0-38.147l13.112-13.112
                                l-13.112-13.112c-10.517-10.517-10.517-27.63,0-38.147L321.306,192.095z M56.436,231.384V197.56
                                c0-23.581,15.484-32.157,35.73-32.157c20.009,0,35.731,8.576,35.731,32.157v33.824c0,23.582-15.722,32.157-35.731,32.157
                                C71.919,263.54,56.436,254.965,56.436,231.384z M106.219,350.482c-8.099,0-13.339-6.669-13.339-12.624
                                c0-1.429,0.476-3.096,1.191-4.526l83.606-171.739c1.906-4.049,5.717-5.955,10.004-5.955c6.669,0,14.053,5.002,14.053,12.624
                                c0,1.429-0.238,3.096-0.952,4.526l-83.846,171.739C115.27,348.1,110.744,350.482,106.219,350.482z M237.226,308.083
                                c0,23.582-15.721,32.157-35.73,32.157c-20.246,0-35.73-8.575-35.73-32.157v-33.824c0-23.582,15.482-32.157,35.73-32.157
                                c20.009,0,35.73,8.575,35.73,32.157V308.083z"
                    />
                  </g>
                </g>
              </svg>
              <p className="mb-0 font-size-12">Vouchers</p>
            </div>
          </Link>
        )}

        {billHistory?.enabled && (
          <Link
            to="/history"
            onClick={triggerVibration}
            className={
              activePage === "history"
                ? "text-decoration-none h-60 active"
                : "text-decoration-none h-60"
            }
          >
            <div className="d-flex flex-column justify-content-around align-items-center">
              <svg
                width="30"
                height="26"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.2918 16.5C26.2918 14.6954 25.7867 12.9268 24.8335 11.3944C23.8804 9.862 22.5174 8.62701 20.8987 7.82919C19.2801 7.03137 17.4704 6.70258 15.6745 6.88004C13.8786 7.05749 12.1683 7.73411 10.7371 8.83331H11.6251C11.9787 8.83331 12.3179 8.97378 12.5679 9.22383C12.8179 9.47388 12.9584 9.81302 12.9584 10.1666C12.9584 10.5203 12.8179 10.8594 12.5679 11.1094C12.3179 11.3595 11.9787 11.5 11.6251 11.5H7.62509C7.27147 11.5 6.93233 11.3595 6.68228 11.1094C6.43223 10.8594 6.29176 10.5203 6.29176 10.1666V9.83331H6.24642L6.29176 9.76397V6.16664C6.29176 5.81302 6.43223 5.47388 6.68228 5.22383C6.93233 4.97378 7.27147 4.83331 7.62509 4.83331C7.97871 4.83331 8.31785 4.97378 8.5679 5.22383C8.81795 5.47388 8.95842 5.81302 8.95842 6.16664V6.83864C11.1371 5.1045 13.8405 4.16231 16.6251 4.16664C19.1287 4.16699 21.5729 4.92925 23.6328 6.35212C25.6928 7.77499 27.2709 9.79108 28.1575 12.1324C29.0441 14.4738 29.1971 17.0295 28.5963 19.4599C27.9954 21.8903 26.6691 24.0803 24.7937 25.7389C22.9183 27.3974 20.5825 28.4459 18.0968 28.745C15.6112 29.0441 13.0934 28.5796 10.878 27.4134C8.66267 26.2471 6.85472 24.4342 5.69446 22.2157C4.5342 19.9972 4.07658 17.4781 4.38242 14.9933C4.46642 14.3106 5.07042 13.8333 5.75842 13.8333C6.54509 13.8333 7.11442 14.592 7.02376 15.3746C6.87094 16.6824 6.98688 18.0075 7.36447 19.2689C7.74206 20.5302 8.37333 21.7011 9.21958 22.7097C10.0658 23.7184 11.1092 24.5435 12.2857 25.1346C13.4622 25.7256 14.7471 26.0701 16.0615 26.1468C17.3759 26.2236 18.6921 26.0311 19.9294 25.581C21.1667 25.1309 22.2991 24.4329 23.257 23.5296C24.2149 22.6263 24.9782 21.5368 25.5 20.3281C26.0219 19.1193 26.2913 17.8166 26.2918 16.5ZM17.9584 11.1666C17.9584 10.813 17.8179 10.4739 17.5679 10.2238C17.3179 9.97378 16.9787 9.83331 16.6251 9.83331C16.2715 9.83331 15.9323 9.97378 15.6823 10.2238C15.4322 10.4739 15.2918 10.813 15.2918 11.1666V17.8333C15.2918 18.1869 15.4322 18.5261 15.6823 18.7761C15.9323 19.0262 16.2715 19.1666 16.6251 19.1666H20.6251C20.9787 19.1666 21.3179 19.0262 21.5679 18.7761C21.8179 18.5261 21.9584 18.1869 21.9584 17.8333C21.9584 17.4797 21.8179 17.1405 21.5679 16.8905C21.3179 16.6404 20.9787 16.5 20.6251 16.5H17.9584V11.1666Z"
                  fill="#8690AB"
                />
              </svg>
              <p className="mb-0 font-size-12">History</p>
            </div>
          </Link>
        )}

        {profileAccess?.enabled && <Link
          to="/profile"
          onClick={triggerVibration}
          className={
            activePage === "profile"
              ? "text-decoration-none h-60 active"
              : "text-decoration-none h-60"
          }
        >
          <div className="d-flex flex-column justify-content-around align-items-center">
            <svg
              width="20"
              height="26"
              viewBox="0 0 22 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8752 0.833374C12.2897 0.833374 13.6462 1.39528 14.6464 2.39547C15.6466 3.39566 16.2085 4.75222 16.2085 6.16671C16.2085 7.5812 15.6466 8.93775 14.6464 9.93794C13.6462 10.9381 12.2897 11.5 10.8752 11.5C9.46068 11.5 8.10412 10.9381 7.10393 9.93794C6.10373 8.93775 5.54183 7.5812 5.54183 6.16671C5.54183 4.75222 6.10373 3.39566 7.10393 2.39547C8.10412 1.39528 9.46068 0.833374 10.8752 0.833374ZM10.8752 14.1667C16.7685 14.1667 21.5418 16.5534 21.5418 19.5V22.1667H0.208496V19.5C0.208496 16.5534 4.98183 14.1667 10.8752 14.1667Z"
                fill="#8690AB"
              />
            </svg>
            <p className="mb-0 font-size-12">Profile</p>
          </div>
        </Link>}
      </div>
    );
  } else {
    return "";
  }
}

export default Navbar;
